var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "341.439px",
    height: "327.863px",
    viewBox: "0 0 341.439 327.863",
    enableBackground: "new 0 0 341.439 327.863",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M148.688,3.852c-22.979,3.098-49.313,13.167-69.45,26.593c-12.264,8.132-29.175,24.397-38.599,37.177  c-9.939,13.296-22.073,38.081-26.204,53.442c-14.717,55.896,0.903,114.244,41.437,154.52c32.918,32.66,73.452,48.537,119.796,46.601  c41.823-1.678,76.291-16.782,106.11-46.601c29.82-29.82,44.924-64.287,46.602-106.111c1.807-45.956-14.071-87.135-45.957-119.278  C259.574,27.217,230.4,11.598,199.418,5.659C186.123,3.078,160.691,2.174,148.688,3.852z M200.968,30.961  c45.053,11.618,80.294,43.502,95.913,87.264c13.555,37.693,8.004,84.811-13.941,117.987c-8.908,13.425-26.463,31.11-39.113,39.63  c-45.827,30.335-107.79,29.562-152.584-2.065c-23.107-16.395-40.922-40.017-50.216-66.61c-17.556-49.958-4.26-104.304,34.339-141.61  c21.041-20.267,45.955-32.66,74.741-37.307C162.369,26.313,188.445,27.734,200.968,30.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M160.822,81.047l-3.744,3.744v41.18c0.128,30.078,0.516,41.825,1.678,43.891  c0.903,1.548,13.684,11.875,28.398,22.978c23.623,17.685,27.367,20.009,31.758,20.009c8.647,0,14.199-8.778,10.973-17.298  c-0.389-1.033-11.49-9.94-24.527-19.751l-23.753-17.814v-35.241c0-28.917-0.388-35.887-1.937-38.985  C175.795,76.142,167.018,74.98,160.822,81.047z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8da45b96486deee4e23d6b23c6738337.svg";
export { ForwardRef as ReactComponent };